import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';
import { EMPTY_ID } from '@e-socna/empty-client';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';

export const MissionReportPage_OneReport_QueryDocument = graphql(`
  query MissionReportPage_OneReport_Query($id: Id!) {
    findOneReport(id: $id) {
      _id
      code
      codingConfig {
        kind
        strategyId
        ... on CodingConfigManual {
          code
        }
        ...CodeCmp_CodingConfig_Fragment
      }
      title
      typeId
      kind
      updatedAt
      contentUpdatedAt
      createdAt
      updaterId
      creatorId
      printing {
        pdfPrints {
          _id
          increment
          file {
            _id
            uri
          }
          isTmp
          createdAt
          creatorId
          automaticMemo
          internalMemo
          memo
        }
        pdfPrintsIncrement
        printSettings {
          addHeaders
          addFooters
          printStyleId
        }
      }
      templateId
      virtualRoot {
        _id
        template {
          _id
          type
        }
        contentOriginId
        isVirtual
        hasPagebreakBefore
        hasPagebreakAfter
        title
        content
        orientation
        paperFormat
        isInsertionPoint
        customLayouts {
          _id
          sectionId
          orientation
          paperFormat
          hasPagebreakAfter
          hasPagebreakBefore
        }
        displayCondition {
          mode
          resolverId
          value
        }

        subSections {
          _id
          template {
            _id
            type
          }
          contentOriginId
          isVirtual
          hasPagebreakBefore
          hasPagebreakAfter
          title
          content
          orientation
          paperFormat
          isInsertionPoint
          customLayouts {
            _id
            sectionId
            orientation
            paperFormat
            hasPagebreakAfter
            hasPagebreakBefore
          }
          displayCondition {
            mode
            resolverId
            value
          }

          subSections {
            _id
            template {
              _id
              type
            }
            contentOriginId
            isVirtual
            hasPagebreakBefore
            hasPagebreakAfter
            title
            content
            orientation
            paperFormat
            isInsertionPoint
            customLayouts {
              _id
              sectionId
              orientation
              paperFormat
              hasPagebreakAfter
              hasPagebreakBefore
            }
            displayCondition {
              mode
              resolverId
              value
            }

            subSections {
              _id
              template {
                _id
                type
              }
              contentOriginId
              isVirtual
              hasPagebreakBefore
              hasPagebreakAfter
              title
              content
              orientation
              paperFormat
              isInsertionPoint
              customLayouts {
                _id
                sectionId
                orientation
                paperFormat
                hasPagebreakAfter
                hasPagebreakBefore
              }
              displayCondition {
                mode
                resolverId
                value
              }

              subSections {
                _id
                template {
                  _id
                  type
                }
                contentOriginId
                isVirtual
                hasPagebreakBefore
                hasPagebreakAfter
                title
                content
                orientation
                paperFormat
                isInsertionPoint
                customLayouts {
                  _id
                  sectionId
                  orientation
                  paperFormat
                  hasPagebreakAfter
                  hasPagebreakBefore
                }
                displayCondition {
                  mode
                  resolverId
                  value
                }

                subSections {
                  _id
                  template {
                    _id
                    type
                  }
                  contentOriginId
                  isVirtual
                  hasPagebreakBefore
                  hasPagebreakAfter
                  title
                  content
                  orientation
                  paperFormat
                  isInsertionPoint
                  customLayouts {
                    _id
                    sectionId
                    orientation
                    paperFormat
                    hasPagebreakAfter
                    hasPagebreakBefore
                  }
                  displayCondition {
                    mode
                    resolverId
                    value
                  }

                  subSections {
                    _id
                    template {
                      _id
                      type
                    }
                    contentOriginId
                    isVirtual
                    hasPagebreakBefore
                    hasPagebreakAfter
                    title
                    content
                    orientation
                    paperFormat
                    isInsertionPoint
                    customLayouts {
                      _id
                      sectionId
                      orientation
                      paperFormat
                      hasPagebreakAfter
                      hasPagebreakBefore
                    }
                    displayCondition {
                      mode
                      resolverId
                      value
                    }

                    subSections {
                      _id
                      template {
                        _id
                        type
                      }
                      contentOriginId
                      isVirtual
                      hasPagebreakBefore
                      hasPagebreakAfter
                      title
                      content
                      orientation
                      paperFormat
                      isInsertionPoint
                      customLayouts {
                        _id
                        sectionId
                        orientation
                        paperFormat
                        hasPagebreakAfter
                        hasPagebreakBefore
                      }
                      displayCondition {
                        mode
                        resolverId
                        value
                      }

                      subSections {
                        _id
                        template {
                          _id
                          type
                        }
                        contentOriginId
                        isVirtual
                        hasPagebreakBefore
                        hasPagebreakAfter
                        title
                        content
                        orientation
                        paperFormat
                        isInsertionPoint
                        customLayouts {
                          _id
                          sectionId
                          orientation
                          paperFormat
                          hasPagebreakAfter
                          hasPagebreakBefore
                        }
                        displayCondition {
                          mode
                          resolverId
                          value
                        }

                        subSections {
                          _id
                          template {
                            _id
                            type
                          }
                          contentOriginId
                          isVirtual
                          hasPagebreakBefore
                          hasPagebreakAfter
                          title
                          content
                          orientation
                          paperFormat
                          isInsertionPoint
                          customLayouts {
                            _id
                            sectionId
                            orientation
                            paperFormat
                            hasPagebreakAfter
                            hasPagebreakBefore
                          }
                          displayCondition {
                            mode
                            resolverId
                            value
                          }

                          subSections {
                            _id
                            template {
                              _id
                              type
                            }
                            contentOriginId
                            isVirtual
                            hasPagebreakBefore
                            hasPagebreakAfter
                            title
                            content
                            orientation
                            paperFormat
                            isInsertionPoint
                            customLayouts {
                              _id
                              sectionId
                              orientation
                              paperFormat
                              hasPagebreakAfter
                              hasPagebreakBefore
                            }
                            displayCondition {
                              mode
                              resolverId
                              value
                            }

                            subSections {
                              _id
                              template {
                                _id
                                type
                              }
                              contentOriginId
                              isVirtual
                              hasPagebreakBefore
                              hasPagebreakAfter
                              title
                              content
                              orientation
                              paperFormat
                              isInsertionPoint
                              customLayouts {
                                _id
                                sectionId
                                orientation
                                paperFormat
                                hasPagebreakAfter
                                hasPagebreakBefore
                              }
                              displayCondition {
                                mode
                                resolverId
                                value
                              }

                              subSections {
                                _id
                                template {
                                  _id
                                  type
                                }
                                contentOriginId
                                isVirtual
                                hasPagebreakBefore
                                hasPagebreakAfter
                                title
                                content
                                orientation
                                paperFormat
                                isInsertionPoint
                                customLayouts {
                                  _id
                                  sectionId
                                  orientation
                                  paperFormat
                                  hasPagebreakAfter
                                  hasPagebreakBefore
                                }
                                displayCondition {
                                  mode
                                  resolverId
                                  value
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      createdAt
      creatorId
      updatedAt
      contentUpdatedAt
      updaterId
    }
  }
`);

export type MissionReportPage_OneReport = ResultOf<
  typeof MissionReportPage_OneReport_QueryDocument
>['findOneReport'];

export const useFindOneReportQuery = (id = EMPTY_ID) =>
  useGraphQLQuery(
    MissionReportPage_OneReport_QueryDocument,
    { id },
    { enabled: !!id },
  );
